import * as Sentry from '@sentry/react';

// Only initialise Sentry when a DSN is explicitly configured. Squares shares the
// same DSN as the pickem frontend (VITE_SENTRY_DSN, from the shared root env), so
// it reports into the same Sentry project. No DSN => no Sentry network traffic.
const dsn = import.meta.env.VITE_SENTRY_DSN;
const environment = import.meta.env.VITE_SENTRY_ENV || 'development';
const isProduction = environment === 'production';

if (dsn && import.meta.env.MODE !== 'test') {
  Sentry.init({
    dsn,
    environment,

    // Performance Monitoring
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],

    // Sample performance traces conservatively to avoid flooding ingest.
    tracesSampleRate: isProduction ? 0.1 : 0.2,

    // Session Replay is a continuous uploader. Don't record normal sessions —
    // buffer in memory and only upload a replay when a session actually errors.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,

    // Enable logs
    enableLogs: true,
  });
}
